import React from "react"
import { Route, Switch } from "react-router"
import { CartProvider } from "react-use-cart"
import { EventContextProvider } from "../../context/EventContext"
import CashCheckout from "../../pages/checkout/CashCheckout"
import Checkout from "../../pages/checkout/Checkout"
import Confirmation from "../../pages/checkout/Confirmation"
import PartialCheckout from "../../pages/checkout/PartialCheckout"
import CustomerRegistryPage from "../../pages/customerRegistry/CustomerRegistryPage"
import FindRegistry from "../../pages/find-registry/FindRegistry"

export const CustomerRouteList = [
  {
    path: "/checkout",
    exact: true,
    component: Checkout
  },
  {
    path: "/partial-checkout",
    exact: true,
    component: PartialCheckout
  },
  {
    path: "/cash-checkout",
    exact: true,
    component: CashCheckout
  },
  {
    path: "/find-registry",
    exact: true,
    component: FindRegistry
  },
  {
    path: "/gift/registry/:slug",
    component: CustomerRegistryPage,
    exact: true
  },
  {
    path: "/checkout/confirm-transaction",
    component: Confirmation,
    exact: true
  }
]

const CustomerRoutes = () => {
  return (
    <Switch>
      <CartProvider id="customer">
        <EventContextProvider>
          {CustomerRouteList.map(r => (
            <Route
              path={r.path}
              exact={r.exact}
              component={r.component}
              key={r.path}
            />
          ))}
        </EventContextProvider>
      </CartProvider>
    </Switch>
  )
}

export default CustomerRoutes
